import { useState } from "react";
import { createPortal } from "react-dom";
import {
  Navbar,
  Nav,
  NavItems,
  NavItem,
  NavLink,
  ButtonLink,
  DropdownMenu,
  DropdownItem,
  SubNavLink,
  Caret,
} from "./styles";
import Filters from "../../../components/Filters";
import SearchBar from "../SearchBar";
import Back from "../Back";
import Icon from "../../../../Icon";
import constants from "../../../../../constants";
import { connect, useDispatch } from "react-redux";
import { Dispatch, Action } from "redux";
import { UserDto } from "../../../../../types/user.dto";

import { Flex } from "../../../../StyledComponents";
import { useLayout } from "../../../../../provider/LayoutProvider";

interface ComponentProps {
  user: UserDto;
}

const Component = ({ user }: ComponentProps) => {
  const { layout } = useLayout();
  const [activeDropdown, setActiveDropdown] = useState<string>();
  const [activeDropdownChildren, setActiveDropdownChildren] =
    useState<string>();
  const dispatch = useDispatch<Dispatch<Action>>();

  const headerSticky = document.getElementById("header-sticky") as HTMLElement;

  if (!headerSticky) {
    throw new Error(
      "Element with id 'header-sticky' not found in the document"
    );
  }

  return createPortal(
    <Navbar>
      <Nav>
        <NavItems>
          <NavItem>{layout.showBackButton && <Back />}</NavItem>

          <NavItem>
            <Flex gap={5} justify="flex-end" aligne="center">
              {layout.showSearchBar && <SearchBar />}
              {layout.showFilters && <Filters />}
            </Flex>
          </NavItem>
        </NavItems>
      </Nav>
    </Navbar>,
    headerSticky
  );
};

const states = ({ userStore }) => {
  const { data: user } = userStore;
  return {
    user,
  };
};

export default connect(states)(Component);
